/* lua.js generated code 0.3.0 */

var TaskChestPreview = xClass("TaskChestPreview", ccui.Layout)
TaskChestPreview.prototype.ctor = function (rewards, column, upText, bottomText, isUp, extraData = {}) {
    var self = this
    ccui.Layout.prototype.ctor.call(self)
    column = column || 1
    self.extraData = extraData
    // self.onClose = null
    self.init(rewards, column, upText, bottomText, isUp)
}
TaskChestPreview.prototype.init = function (rewards, column, upText, bottomText, isUp) {
    var self = this
    self.setAnchorPoint(cc.p(0.5, 1))
    var bubble = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/bagTipBg.png")
    self.addChild(bubble)
    var arrow = cc.Sprite.createWithSpriteFrameName("uilibrary/boxTipTail.png")
    self.addChild(arrow)
    self.bubble = bubble
    self.arrow = arrow
    var rewardCount = 0
    if (rewards != null)
       rewardCount = $len(rewards)
    var bubbleWidth = 180
    var itemWidth = 140
    var itemHeight = 80
    var lBorder = self.extraData.lBorder || 30
    var rBorder = self.extraData.rBorder || 60
    var border = self.extraData.border || 20
    var [topOffset, bottomOffset] = [0, 0]
    var totalWidth = lBorder + rBorder + itemWidth * column
    var totalHeight = 40 + itemHeight * Math.ceil(rewardCount / column)
    var upperTextBox, bottomTextBox
    if (upText) {
        upperTextBox = cc.LabelTTF.create(tostring(upText), null, 24, cc.size(totalWidth - lBorder * 2, 0))
        upperTextBox.setFontFillColor(cc.c3b(0, 0, 0))
        upperTextBox.setHorizontalAlignment(0)
        var size = upperTextBox.getContentSize()
        self.addChild(upperTextBox, 3, "UpperText")
        totalHeight = totalHeight + size.height + border
        topOffset = size.height + border
    }
    if (bottomText) {
        bottomTextBox = cc.LabelTTF.create(tostring(bottomText), null, 24, cc.size(totalWidth - lBorder * 2, 0))
        bottomTextBox.setFontFillColor(cc.c3b(0, 0, 0))
        bottomTextBox.setHorizontalAlignment(self.extraData.bottomTextAlignment || 0)
        var size = bottomTextBox.getContentSize()
        totalHeight = totalHeight + bottomTextBox.getContentSize().height + border
        self.addChild(bottomTextBox, 3, "BottomText")
        bottomOffset = size.height + border
    }
    if (upperTextBox) {
        var size = upperTextBox.getContentSize()
        upperTextBox.setPosition(cc.p(totalWidth / 2, totalHeight - size.height / 2 - border))
    }
    if (bottomTextBox) {
        var size = bottomTextBox.getContentSize()
        bottomTextBox.setPosition(cc.p(totalWidth / 2, size.height / 2 + border))
    }
    bubble.setContentSize(cc.size(totalWidth, totalHeight))
    self.setContentSize(cc.size(totalWidth, totalHeight))
    bubble.setAnchorPoint(cc.p(0, 0))
    bubble.setPosition(0, 0)
    if (self.extraData.left){
        self.setAnchorPoint(0, 0.5)
        arrow.setAnchorPoint(0.5, 0)
        arrow.setRotation(90)
        arrow.setPosition(-15, totalHeight*0.5)
    }else if (self.extraData.right){
        self.setAnchorPoint(1, 0.5)
        arrow.setAnchorPoint(0.5, 0)
        arrow.setRotation(-90)
        arrow.setPosition(-15, totalHeight * 0.5)

    }else{
        if (isUp) {
            self.setAnchorPoint(0.5, 0)
            arrow.setAnchorPoint(0.5, 0)
            arrow.setPosition(totalWidth / 2, -15)
        } else {
            arrow.setAnchorPoint(0.5, 0)
            arrow.setFlippedY(true)
            arrow.setPosition(totalWidth / 2, totalHeight - 2)
        }
    }
    function getItemPos(i) {
        var row = Math.floor((i - 1) / column) + 1
        var col = Math.mod((i - 1), column) + 1
        // FIXME: multi result
        return [-30 + totalWidth / 2 + (col - (column + 1) / 2) * itemWidth, totalHeight - topOffset - (row - 1) * itemHeight - 60]
    }
    if (rewards != null && rewardCount > 0){
        for (var i = 1, v = rewards[1]; v; i++, v = rewards[i]) {
            var icon = UIItemBuilder.createProp(v.itemId, v.num, 1)[0]
            var [posX, posY] = getItemPos(i)
            icon.setPosition(posX, posY)
            self.addChild(icon, 5)
        }
    }
    self.registerTouchEvents()
}
TaskChestPreview.prototype.popup = function (duration, onCloseCallback) {
    var self = this
    self.onCloseCallback = onCloseCallback
    self.stopAllActions()
    self.setScale(0.1)
    self.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, 1.2), cc.ScaleTo.create(0.05, 1), cc.DelayTime.create(duration || 86400), cc.CallFunc.create(function () {
        self.playCloseAnimation()
    })))
}
TaskChestPreview.prototype.popupToScale = function (duration, scale = 1) {
    var self = this
    self.stopAllActions()
    self.setScale(0.1 * scale)
    self.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, scale * 1.2), cc.ScaleTo.create(0.05, scale), cc.DelayTime.create(duration || 86400), cc.CallFunc.create(function () {
        self.playCloseAnimation()
    })))
}
TaskChestPreview.prototype.popupLittle = function(duration, scale) {
    var self = this
    self.isLittleIn = true
    self.stopAllActions()
    self.setScale(0.1)
    self.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, scale+0.2), cc.ScaleTo.create(0.05, scale), cc.DelayTime.create(duration || 86400), cc.CallFunc.create(function () {
        self.playCloseAnimation()
    })))
}
TaskChestPreview.prototype.playCloseAnimation = function () {
    var self = this
    self.stopAllActions()
    self.runAction(cc.Sequence.create(cc.Spawn.create(cc.ScaleTo.create(0.1, 0), cc.FadeOut.create(0.1)), cc.CallFunc.create(() => {
        self.onCloseCallback && self.onCloseCallback()
        self.onClose && self.onClose()
    }), cc.RemoveSelf.create(true)))
}
TaskChestPreview.prototype.isTouchInBox = function (tp) {
    var self = this
    var size = self.getContentSize()
    var leftBottom = cc.p(0, 0)
    var rightUpper = cc.p(size.width, size.height)
    var lb = self.convertToWorldSpace(leftBottom)
    var ru = self.convertToWorldSpace(rightUpper)
    return tp.x > lb.x && tp.x < ru.x && tp.y > lb.y && tp.y < ru.y
}
TaskChestPreview.prototype.getContentSize = function () {
    var self = this
    // WARN: maybe multi result
    return self.bubble.getContentSize()
}
TaskChestPreview.prototype.onTouchOutside = function () {
    var self = this
    if(self.isLittleIn) {
        return
    }
    self.playCloseAnimation()
}
TaskChestPreview.prototype.onClose = function () {
    
}
TaskChestPreview.prototype.cleanup = function () {
    var self = this
    cc.eventManager.removeListener(self.listener)
    ccui.Layout.prototype.cleanup.call(self)
}
TaskChestPreview.prototype.registerTouchEvents = function () {
    var self = this
    function onTouchBegan(touch, event) {
        var tp = touch.getLocation()
        if (self.isTouchInBox(tp)) {
            return true
        } else {
            self.onTouchOutside()
            return false
        }
    }
    var listener = cc.EventListenerTouchOneByOne.create()
    listener.setSwallowTouches(true)
    listener.registerScriptHandler(onTouchBegan, cc.Handler.EVENT_TOUCH_BEGAN)
    cc.eventManager.addListener(listener, self)
    self.listener = listener
    // var eventDispatcher = self.getEventDispatcher()
    // eventDispatcher.addEventListenerWithSceneGraphPriority(listener, self)
}
module.exports = TaskChestPreview
